export enum CashierType {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}

export type CashierModal = {
  isOpen: boolean;
  type?: CashierType;
  promoCode?: string;
  amount?: number;
  promoTag?: string;
};

export interface CashierState {
  cashierModal: CashierModal;
}
